// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"989cbf5c191e78576a4d","147":"68f7a9a7147a940d4a10","251":"bcc45067e3fb5827c5e7","352":"66693b0c6f62a6ade787","631":"7f6481807ea5020ff807"}[chunkId] + ".js";
};